import { light_offer_extended } from "../models/light_offer_extended";

export default function isSpecialCoupon(offer: light_offer_extended): boolean {
  const hasDefaultTarget = offer.default_target === true;
  const hasHolderRequired = offer.is_holder_required === false;
  const clippable_dates = offer.clippable_dates;
  return (
    hasDefaultTarget &&
    hasHolderRequired &&
    clippable_dates !== undefined &&
    clippable_dates.length > 0
  );
}
